import axios from "axios"

const URL = process.env.REACT_APP_API_URL
const BASE_URL = `${URL}/api/blogs`
const axiosApi = axios.create({ baseURL: BASE_URL })

axiosApi.interceptors.request.use(req => {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
        req.headers.Authorization = token
    }
    return req
})

export const BlogApis = {
    listAdmin: async (page, limit, search) =>
        axiosApi.get(`${BASE_URL}/admin?page=${page}&limit=${limit}&search=${search || ''}`),
    getById: async (id) => axiosApi.get(`${BASE_URL}/admin/${id}`),
    create: async (data) => axiosApi.post(BASE_URL, data),
    update: async (id, data) => axiosApi.put(`${BASE_URL}/${id}`, data),
    delete: async (id) => axiosApi.delete(`${BASE_URL}/${id}`),
    uploadImage: async (formData) =>
        axiosApi.post(`${BASE_URL}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
}
